import { mapAccountSectionToAuditTag } from '../../../../../../backend/features/accounts/shared';
import { useUserState } from '../../../../../../ui/hooks';
import React from 'react';
import { AccountMembershipTable } from '../../AccountPage/components/AccountMembership/AccountMembershipTable';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const AccountMembershipUserNew = React.forwardRef((props, ref) => {
    var _a, _b, _c;
    const userState = useUserState();
    if (!props.accountId) {
        return null;
    }
    const auditTags = [mapAccountSectionToAuditTag(props.section.columns)];
    return (React.createElement(AccountMembershipTable, { accountId: props.accountId, auditTags: auditTags, staticDialogFilters: {
            visible: ((_a = props.formParams) === null || _a === void 0 ? void 0 : _a.id) === (userState === null || userState === void 0 ? void 0 : userState.id),
            orgPermissions: ((_b = props.formParams) === null || _b === void 0 ? void 0 : _b.id) !== (userState === null || userState === void 0 ? void 0 : userState.id) ? ['manage-members', 'view-and-transfer-members'] : undefined,
            permission: ((_c = props.formParams) === null || _c === void 0 ? void 0 : _c.id) === (userState === null || userState === void 0 ? void 0 : userState.id) ? 'member' : undefined,
        } }));
});
